import router from 'next/router';
import RightIcon from 'src/assets/svgExports/RightIcon';
import { useSSRSelector } from 'src/redux';
import { RootState } from 'src/redux/reducers';
import { getThemeColor } from 'src/utils/getThemeColor';
import { getRoute, PATH } from 'src/utils/routes';

export const GoToCartSection = ({
  customClasses = '',
  primaryButtonClasses = '',
  secondaryButtonClasses = '',
}) => {
  const themeColor = getThemeColor();
  const domain = useSSRSelector((state: RootState) => state.storeReducer.store.domain);

  return (
    <div
      className={`tw-flex tw-items-center tw-gap-[28px] tw-text-nowrap ${customClasses} `}
    >
      <span
        className={`tw-flex tw-items-center tw-gap-[4px] tw-text-[14px]/[20px] tw-font-medium ${secondaryButtonClasses}`}
      >
        Added to cart <RightIcon />
      </span>
      <button
        className={`tw-w-50% tw-mr-[24px] tw-cursor-pointer tw-border-none tw-px-[20px] tw-py-[8px] tw-text-[16px]/[22px] tw-font-semibold tw-text-white ${primaryButtonClasses}`}
        style={{ backgroundColor: themeColor }}
        onClick={() => router.push(getRoute(PATH.CART, domain))}
      >
        View Cart
      </button>
    </div>
  );
};
